<template>
  <div :id="listId" class="select-single-level comp-start">
    <div class="select-card-ques">
      {{ info.message }}
    </div>
    <div id="dropdownMenu" class="dropdown">
      <button
        id="dropdownMenuButton"
        class="btn dropdown-button"
        type="button"
        data-display="static"
        :class="!showIcon ? 'dropdown-border' : 'dropdown-border-open'"
        @click="onMenuClick($event)"
      >
        <span
          :style="dDWidth"
          class="float-left select-placeholder"
          :class="selectedItem.name ? '' : 'select-placeholder-default'"
          >{{ selectPlaceholder }}</span
        >
        <span class="float-right button-arrow dropdown-button-arrow">
          <img
            v-if="showIcon || null"
            class="dropdown-button-arrow-img"
            src="@/assets/img/dropdown-up-icon.png"
          />
          <img
            v-else-if="!showIcon || null"
            class="dropdown-button-arrow-img"
            src="@/assets/img/dropdown-icon.png"
          />
        </span>
      </button>

      <div v-show="showIcon" aria-labelledby="dropdownMenuButton">
        <div id="search-btn" style="display: flex">
          <img
            v-if="enableSearch ? true : null"
            src="@/assets/img/Group.svg"
            class="search-icon"
          />
          <input
            v-if="enableSearch ? true : null"
            ref="search"
            v-model="search"
            type="text"
            :placeholder="searchPlaceholder"
            class="search-dropdown"
          />
        </div>

        <form id="dropdown-scroll" class="dropdown-scroll">
          <a
            v-for="(item, itemIndex) in list"
            :key="itemIndex"
            class="dropdown-item"
            href="javascript:void(0)"
            :class="selectedItem.id === item.id ? 'selected-item' : ''"
            @click="onSelectItem(item)"
          >
            <div class="dropdown-checkbox-circle-division">
              <input
                class="checkbox-custom"
                type="checkbox"
                :checked="selectedItem.id === item.id ? true : false"
              />
              <label for="checkbox-1" class="checkbox-custom-label" />
            </div>
            <div class="dropdown-item-text-division">
              {{ item.name }}
            </div>
          </a>
        </form>
        <!--
 <a class="dropdown-item" href="javascript:void(0)">
              <button type="button" class="btn confirm-btn" @click="onClickConfirm()">Confirm</button>
        </a>
-->
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Watch } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import _ from "underscore";
import Utils from "@/utils/utilities";
import $ from "jquery";
import store from "@/store";
import EventEmitter from "@/utils/eventEmitter";

const selectDefaultPlaceholder = "Select";

@Component({})
export default class DropDownSingleLevel extends Vue {
  public list: any = [];
  public masterList: any = [];
  public search = "";
  public itemSelectedIndex = -1;
  public selectedItem: any = { name: "", id: "" };
  public selectPlaceholder: string = selectDefaultPlaceholder;
  public showIcon = false;
  public listId = "";
  public dropdownWidth = 100;
  public searchPlaceholder = "Search..";

  //public finalSelectedItem : any= {'name': '', 'id':''};
  public primaryPlaceholder = "";

  @Prop()
  public info!: any;

  @Prop()
  public enableSearch!: boolean;

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("showIcon")
  onClickMenuButton() {
    EventEmitter.emit("APP_NEXT_PANEL_VISIBITITY", this.showIcon);
  }

  @Watch("search")
  onChangeSearchVal() {
    this.searchString();
  }
  @Watch("languageList")
  changeLanguageList() {
    this.updateUIVariables();
  }

  adjustDropdownWidth() {
    this.dropdownWidth = Utils.dropDownFitContent(
      this.list,
      this.primaryPlaceholder,
      "singleselect",
    );
  }

  get dDWidth() {
    return {
      width: `${
        window.innerWidth > 500 ? this.dropdownWidth + 1 + "px" : "100%"
      } !important`,
      //  'max-width': `${this.dropdownMaxWidth}% !important`,
      "padding-bottom": "0px",
    };
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  updateUIVariables() {
    this.searchPlaceholder = this.getUiText(
      "app-prospect-questions-search-text-1",
    );
  }

  async mounted() {
    window.removeEventListener("click", () => {});
    if (this.info && this.info.id) {
      this.listId = "select-" + this.info.id;
    }
    if (this.info && this.info.type_values) {
      let listKeyInJSON = await Utils.getQuestionsMatchedListKey(this.info.id);

      if (
        this.info.type_values[listKeyInJSON] &&
        this.info.type_values[listKeyInJSON].length > 0
      ) {
        this.list = this.info.type_values[listKeyInJSON];
        this.list = _.sortBy(this.list, "order");
      }
      this.masterList = this.list;
    }

    if (this.info && this.info.values && this.info.values.length > 0) {
      this.selectedItem = this.masterList.find(
        (r: any) => r.id === this.info.values[0],
      );
      //this.finalSelectedItem = this.selectedItem;
    }

    this.primaryPlaceholder = this.getUiText(
      "app-prospect-questions-select-text-1",
    );
    if (this.info.name) {
      this.primaryPlaceholder += " " + this.info.name;
    }

    this.setPlaceholderValue();

    const context = this;
    setTimeout(function () {
      context.getInputPosition();
    }, 1000);

    window.addEventListener("resize", this.adjustDropdownWidth);

    window.addEventListener("click", (e: any) => {
      const targetClassList: string[] = [...e.target.classList];

      if (
        !targetClassList.includes("select-placeholder") &&
        !targetClassList.includes("search-dropdown") &&
        !targetClassList.includes("dropdown-button-arrow") &&
        !targetClassList.includes("dropdown-button-arrow-img")
      ) {
        this.showIcon = false;
      }
    });

    const dropdownMenu = document.getElementById("dropdownMenu");
    if (dropdownMenu) {
      dropdownMenu.addEventListener("hidden.bs.dropdown", this.onCloseMenuList);
    }
    this.adjustDropdownWidth();
    this.updateUIVariables();
  }
  searchString() {
    const context = this;
    this.list = _.filter(this.masterList, function (item: any) {
      return (
        item.name.toLowerCase().indexOf(context.search.toLowerCase()) != -1
      );
    });
  }
  onCloseMenuList() {
    this.showIcon = false;
  }
  onSelectItem(item: any) {
    if (item && item.id) {
      if (this.selectedItem && this.selectedItem.id === item.id) {
        // to deselect selected item.
        this.selectedItem = {};
      } else {
        this.selectedItem = item;
      }
    } else {
      this.selectedItem = {};
    }
    this.showIcon = false;
    this.setPlaceholderValue();
  }
  // onClickConfirm(){
  //     this.finalSelectedItem = Object.assign({},this.selectedItem);
  //     if(this.selectedItem && this.selectedItem.id){
  //         this.setPlaceholderValue();
  //     }
  //     else{
  //       this.selectedItem = {};
  //       this.setPlaceholderValue();
  //     }
  // }
  setPlaceholderValue() {
    if (this.selectedItem.name) {
      this.selectPlaceholder = this.selectedItem.name;
    } else if (this.info.prompt) {
      this.selectPlaceholder = this.info.prompt;
    } else {
      this.selectPlaceholder = this.primaryPlaceholder;
    }
  }
  getInputPosition() {
    const inputElem: any = document.getElementById("" + this.listId);
    if (inputElem && this.info.guidance && this.info.guidance !== null) {
      const inputPosition = inputElem.getBoundingClientRect();
      EventEmitter.emit("APP_INPUT_POSITION", inputPosition.top);
    }
  }
  onMenuClick(e: any) {
    this.showIcon = !this.showIcon;
    setTimeout(() => {
      this.enableSearch && $(this.$refs.search as any).focus();
    }, 100);
    if (this.showIcon && e && e.currentTarget && e.currentTarget.id) {
      EventEmitter.emit("APP_SCROLL_BOTTOM_CUSTOM", e.currentTarget.id);
    }
    var searchBtn = document.getElementById("search-btn");
    var dDButton = document.getElementById("dropdownMenuButton");
    var dDForm = document.getElementById("dropdown-scroll");

    if (searchBtn && dDButton && dDForm) {
      searchBtn.style.width = dDButton.clientWidth + "px";
      dDForm.style.width = dDButton.clientWidth + "px";
    }
  }
  beforeUnmount() {
    window.removeEventListener("resize", this.adjustDropdownWidth);
    window.removeEventListener("click", () => {});
    this.selectedItem = {};
    //this.finalSelectedItem = {};
    this.showIcon = false;
  }
}
</script>
<style lang="scss" scoped>
.select-card-ques {
  color: #231f20;
}
.dropdown-button {
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  width: fit-content;
  color: #0345bd;
  display: flex !important;
  padding-left: 5px;
  border: 0px !important;
}

.dropdown-button-arrow {
  padding-left: 20px;
}

.select-placeholder {
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 48px;
  text-align: left;
  word-break: break-word;
}
.select-placeholder-default {
  color: #b7b7b7;
}
.select-placeholder::placeholder {
  font-size: 32px;
}
.dropdown-menu {
  padding: 0px;
}
.dropdown-menu.show {
  margin-top: 0px;
  width: 100% !important;
  box-shadow: 0px 4px 10px rgba(183, 183, 183, 0.4);
  border-radius: 6px;
  border: none;
  display: contents;
}
.dropdown-item {
  color: #0345bd;
  overflow-x: hidden;
  font-size: 18px;
  padding: 10px 10px 10px 20px;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: 100%;
  display: flex;
  align-items: center;
}
.checkbox-custom {
  opacity: 0;
  position: absolute;
  width: 24px;
  height: 24px;
}

.checkbox-custom,
.checkbox-custom-label {
  display: inline-block;
  vertical-align: middle;
  margin: 5px;
  cursor: pointer;
  text-align: justify;
  word-break: break-word;
  line-height: 1em !important;
  white-space: normal;
}

.checkbox-custom-label {
  position: relative;
  top: 0%;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
}

.checkbox-custom + .checkbox-custom-label:before {
  content: "";
  background: #fff;
  border: 2px solid #0345bd;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  padding: 0px;
  margin-right: 10px;
  text-align: center;
  border-radius: 50%;
}

.checkbox-custom:focus + .checkbox-custom-label,
.radio-custom:focus + .radio-custom-label {
  outline: 1px solid #ddd; /* focus style */
}
.search-icon {
  position: absolute;
  margin-top: 10px;
  left: 20px;
  display: grid;
}
.confirm-btn {
  border: 3px solid #0345bd;
  border-radius: 200px;
  color: #0345bd;
  font-size: 16px;
  padding: 10px 20px;
  width: unset !important;
}
.search-dropdown {
  border: none;
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
  width: 100%;
  font-size: 18px;
  padding: 10px;
  padding-left: 53px;
  line-height: 27px;
  font-style: normal;
  font-weight: 500;
}
.selected-item {
  background: #0345bd;
  box-shadow: 0px 0px 10px rgba(183, 183, 183, 0.4);
  color: white;
  border: none;
}
.dropdown-border {
  border: 3px solid #ffffff;
}
.dropdown-border-open {
  border-bottom: 1px solid rgba(183, 183, 183, 0.25);
}

@media only screen and (min-width: 3840px) {
  .search-icon {
    margin-top: 30px;
  }
}

@media (max-width: 500px) {
  .dropdown {
    width: 100%;
  }
  .dropdown-button {
    width: 100%;
  }
}

.dropdown-item-text-division {
  display: inline-block;
  width: 90%;
  white-space: normal;
  word-break: word-break;
  //position:relative;
  //left:5%;
  margin-left: 2%;
}

.dropdown-checkbox-circle-division {
  display: inline-block;
}

@media (max-width: 812px) and (min-width: 769px) and (orientation: landscape) {
  .dropdown-button {
    width: fit-content !important;
  }
}
</style>
